var render = function () {
  var _vm$currentRound$step;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'bits-about-it'
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content",
      "id": "bits-about-it-content"
    },
    slot: "content"
  }, [_c('aside', _vm._l((_vm$currentRound$step = _vm.currentRound.steps) === null || _vm$currentRound$step === void 0 ? void 0 : _vm$currentRound$step.filter(function (step) {
    var _step$optionalImage, _step$optionalImage$i;
    return !!((_step$optionalImage = step.optionalImage) !== null && _step$optionalImage !== void 0 && (_step$optionalImage$i = _step$optionalImage.image) !== null && _step$optionalImage$i !== void 0 && _step$optionalImage$i.src);
  }), function (step) {
    var _step$optionalImage2, _step$optionalImage2$, _step$optionalImage3, _step$optionalImage3$, _step$optionalImage4, _step$optionalImage4$, _step$optionalImage5, _step$optionalImage5$;
    return _c('figure', {
      key: (_step$optionalImage2 = step.optionalImage) === null || _step$optionalImage2 === void 0 ? void 0 : (_step$optionalImage2$ = _step$optionalImage2.image) === null || _step$optionalImage2$ === void 0 ? void 0 : _step$optionalImage2$.id,
      class: ("image id-" + ((_step$optionalImage3 = step.optionalImage) === null || _step$optionalImage3 === void 0 ? void 0 : (_step$optionalImage3$ = _step$optionalImage3.image) === null || _step$optionalImage3$ === void 0 ? void 0 : _step$optionalImage3$.id)),
      attrs: {
        "aria-hidden": true
      }
    }, [_c('img', {
      attrs: {
        "alt": (_step$optionalImage4 = step.optionalImage) === null || _step$optionalImage4 === void 0 ? void 0 : (_step$optionalImage4$ = _step$optionalImage4.image) === null || _step$optionalImage4$ === void 0 ? void 0 : _step$optionalImage4$.description,
        "src": (_step$optionalImage5 = step.optionalImage) === null || _step$optionalImage5 === void 0 ? void 0 : (_step$optionalImage5$ = _step$optionalImage5.image) === null || _step$optionalImage5$ === void 0 ? void 0 : _step$optionalImage5$.src
      }
    })]);
  }), 0), _c('div', {
    class: {
      'text-display-lists-container': true,
      isMobile: _vm.isMobile
    }
  }, _vm._l(_vm.currentRound.chunckedSteps, function (steps, stepIndex) {
    return _c('text-display-list', {
      key: stepIndex
    }, _vm._l(steps, function (_ref, index) {
      var id = _ref.id,
        answer = _ref.answer;
      return _c('li', {
        key: index,
        class: [("step answer-" + id)]
      }, [_c('blinking-cursor-text', {
        attrs: {
          "text": answer,
          "text-step": 2 * stepIndex + index
        }
      })], 1);
    }), 0);
  }), 1)])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }